<template>
    <div  class="cart-list scroll-list" style="padding-top: 0.5rem;clear: both;">
		<div class="cart-li" v-for="(item,index) in cart" :key="index">
			
			<input class="cart-checkbox" type="checkbox" :value="item.cart_id" @change="changeCartChecked"  v-model="checkedValue" />
			
			<img class="cart-img" :src="item.goods_image" @click="toGoods(item.goods_id)" />
			<div style="width: 6rem; float: left;">
				<br><span style="">{{item.goods_name}}</span>
				<br>
				<br>
				<br><span style="" >￥{{item.goods_price}}</span>
			</div>
			<div style="width: 4rem;float: right; margin-top: 2rem;">
				<span class="cart-add-button" @click="changeCartNum(item.cart_id, '-');">-</span>
				<span> {{item.cart_num}} </span>
				<span class="cart-add-button" @click="changeCartNum(item.cart_id, '+');">+</span>
			</div>
		</div>
 
		<!-- <div>Checked names: {{ checkedValue }}</div> -->

		<!-- 组件使用 -->
		<syalert ref="syalert_id" />
	
    </div>
</template> 

<style>
    

.cart-list{
	width: 90%;
    margin: 0 auto;
	font-size: 0.5rem;
}
.cart-li{
    box-shadow: 0px 0px .3rem #ccc;
    /* border:1px solid #fefefe; */
	
    border-radius: 0.5rem; 
    margin: 0.5rem 0;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
	padding-left: 0.5rem;
}
.cart-li::after{
    content: "";
    display: block;
    clear: both;
}
/* 隐藏默认的 checkbox */
.cart-checkbox[type="checkbox"]
{
	float: left;
	margin-top: 1.5rem;
	
	appearance: none;
	-webkit-appearance: none;
	-moz-appearance: none;
	width: 1rem;
	height: 1rem;
	border-radius: 50%;
	border: 2px solid #ccc;
	outline: none;
	cursor: pointer;
	transition: background-color 0.3s ease;
}
 /* 当 checkbox 被选中时，显示一个内部的圆点 */
.cart-checkbox[type="checkbox"]:checked {
	background-color: #4CAF50; /* 圆点的颜色 */
}
 /* 在选中的 checkbox 内部添加一个小的白色圆点 */
.cart-checkbox[type="checkbox"]:checked::after {
            content: '';
            position: absolute;
            left: 7px;
            top: 3px;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: white;
        }

.cart-img{
	float: left;
    width: 4rem;
	margin: 0 0.5rem;
    border-radius: 0.5rem; 
    /*阻止识别照片*/
    /* pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none; */
}
.cart-list li div{
	display: inline-block;
    font-size: .8rem;
}

.cart-add-button{
	display: inline-block;
	width: 0.8rem;
	height: 0.8rem;

	font-size: 0.8rem;
	text-align: center;
	line-height: 0.8rem;
	
	color: #ccc;
	border: 1px solid #ccc;
	/* background-color: white; */
}
  
</style>
<script>

	import sy from "@/sy";
    import syalert from '@/components/syalert.vue';
	
export default {
  name: 'cartList',
  props:{
    cart:{}
  },
  components: {
	syalert,
  },
  data(){
      return{
		// cart_list: [],
		checkedValue:[],
      }
  },
  methods:
  {
	changeCartNum:function(cart_id, tg)
	{
		for( var i=0;i < this.cart.length; i++ )
		{
			if( cart_id === this.cart[i].cart_id )
			{
				if( tg === '+' )
				{
					this.cart[i].cart_num++;
				}else{
					if(parseInt(this.cart[i].cart_num) === 1)
					{ 
						return this.$refs.syalert_id.syalert('不能减为0', 3000);
					}
					this.cart[i].cart_num--;
				}
			}
			//console.log(this.cart[i].cart_id);
		}
		
		
		// ----- ----- 实例重命名
		let $_this = this;
		sy.http.get({
			url: this.$root.API + 'Cart/Set',
			data: {
				tg: tg,
				cart_id: cart_id,
			},
			success: function(res) 
			{
				if (res.state == '0') 
				{
					$_this.$refs.syalert_id.syalert(res.msg, 3000);
				}
			}
		});
		
		
		this.changeCartChecked();
		
	},
	toGoods:function(gid)
	{
		this.$router.push('/goods?gid='+gid);
	},
	// 检测cart_checkebox 变化
	// 创建一个数组，便利数据，根据判断，修改对应数据，再由父级 处理变化
	changeCartChecked:function()
	{
		let map = [];
		for(let x of this.checkedValue )
		{
			map.push(x);
			// console.log(x);
		}
		// console.log(map);
		for( var i=0;i < this.cart.length; i++ )
		{
			if(  map.includes(this.cart[i].cart_id) === true )
			{
				this.cart[i].cart_checked = '1';
			}else{
				this.cart[i].cart_checked = '0';
			}
		}
		// console.log(this.cart);

		
		// 向父级传递事件 父级需绑定接收
		// this.$emit('cartChanged', this.checkedValue);
		this.$emit('cartChanged');


		//console.log(this.checkedValue);
		//console.log(this.cart);

	},
	
	
  }
}
</script>